import { _, Backbone, Radio } from "../../vendor";
import InboomaBaseModel from "./InboomaBaseModel";
import Voucher from "./Voucher";

export default InboomaBaseModel.extend({
  urlRoot: "/voucher_types",

  _save(key, val, options) {
    //this.beforeSave(key, val, options);
    console.log("save voucher model hook", key, val, options);
    return Backbone.Model.prototype.save.call(this, key, val, options);
  },

  _rbac: {
    admin: {
      read: true,
      write: true,
      edit: true,
      remove: true,
    },
    user: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    manager: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    "booking-manager": {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    "manager-location": {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
  },

  defaults: {
    id: "",
    client_id: null,
    name: "",
    description: "",
    status: true,
    role: "manager",
    type: "discount",
    voucher_unit: "percentage",
    voucher_value: "",
    multiple_use: 0,
    sellable: 0,
    contingents: [],
    contingent_number: 0,
    days_number: 0,
    valid_to: "",
    created: "",
    created_by: "",
    modified: "",
    modified_by: "",
    deleted: "",
    codes_source: "none",
    codes: [],
    codes_file: null,
    codes_area: "",
    codes_generate_count: "",
    use_for: "contingent",
  },

  getInvalidCodes: function (codes) {
    let invalidCodes = [];

    let vouchers = Radio.channel("vouchers").request("get:data");

    codes.forEach((codeItem) => {
      let matchingCode = vouchers.models.find((item) => item.get("voucher_code") === codeItem);
      if (matchingCode !== undefined) {
        invalidCodes.push(codeItem);
      }
    });

    return invalidCodes;
  },

  validate: function (attributes, options) {
    if (isNaN(this.get("voucher_value"))) {
      return "voucher_value_is_nan";
    }

    if (this.get("codes_source") !== "none") {
      let codes_source = this.get("codes_source");
      let codes = [];

      switch (codes_source) {
        case "text":
        case "file":
          codes = this.get("codes_area")
            .split(";")
            .map((item) => item.trim());
          break;
      }

      let invalidCodes = this.getInvalidCodes(codes);
      if (invalidCodes.length) {
        return (t) =>
          t("voucher_codes_already_exist_${a}", { a: invalidCodes.join(", ") }, null, "capital");
      } else {
        this.set("codes", codes);
      }
    }
  },
});
